/**
 * Enhanced middleware creator for Edge Runtime
 * Uses EdgeAgentDetector which doesn't require WASM
 */

import { NextResponse } from 'next/server';
import type { NextRequest } from 'next/server';
import { createAgentShieldMiddleware as createBaseMiddleware } from './middleware';
import type { NextJSMiddlewareConfig } from './types';

let middlewareInstance: any = null;
let isInitializing = false;
let initPromise: Promise<any> | null = null;

/**
 * Create an AgentShield middleware with automatic WASM initialization
 * This version handles initialization internally to avoid top-level await
 */
export function createAgentShieldMiddleware(config: NextJSMiddlewareConfig) {
  return async function agentShieldMiddleware(
    request: NextRequest
  ): Promise<NextResponse> {
    // Initialize middleware on first request (no WASM needed in Edge Runtime)
    if (!middlewareInstance) {
      if (!isInitializing) {
        isInitializing = true;
        initPromise = (async () => {
          // No WASM initialization needed - EdgeAgentDetector works without it

          // Create the actual middleware instance
          middlewareInstance = createBaseMiddleware(config);
          return middlewareInstance;
        })();
      }

      // Wait for initialization to complete
      if (initPromise) {
        middlewareInstance = await initPromise;
      }
    }

    // Run the middleware
    return middlewareInstance
      ? middlewareInstance(request)
      : NextResponse.next();
  };
}

/**
 * Export the original function as well for backward compatibility
 */
export { createAgentShieldMiddleware as createMiddleware };
